export var ThemeEvent;
(function (ThemeEvent) {
    ThemeEvent[ThemeEvent["theme:section:navigate"] = 0] = "theme:section:navigate";
    ThemeEvent[ThemeEvent["theme:section:load"] = 1] = "theme:section:load";
    ThemeEvent[ThemeEvent["theme:section:update"] = 2] = "theme:section:update";
})(ThemeEvent || (ThemeEvent = {}));
